import React from "react";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { payoutService } from "./service";
import { monthLabel } from "./constant";
import TransactionDetailsModal from "./TransactionDetailsModal";
import { PayoutBilling, PayoutDisbursal } from "../../types/payouts";

type DisbursalTabProps = {
  specialistId: string;
  refreshKey?: number;
};

const DisbursalTab: React.FC<DisbursalTabProps> = ({
  specialistId,
  refreshKey = 0,
}) => {
  const [rows, setRows] = React.useState<PayoutDisbursal[]>([]);
  const [selected, setSelected] = React.useState<PayoutDisbursal | null>(null);

  const fetchHistory = React.useCallback(async () => {
    if (!specialistId) return;
    const data = await payoutService.fetchDisbursalHistory(specialistId);
    setRows(Array.isArray(data) ? (data as PayoutDisbursal[]) : []);
  }, [specialistId]);

  React.useEffect(() => {
    fetchHistory();
  }, [fetchHistory, refreshKey]);

  const handleReceipt = async (disbursalId: string) => {
    const data = await payoutService.getReceipt(disbursalId);
    if (data?.invoice_url) {
      window.open(`http://localhost:4030${data.invoice_url}`, "_blank");
    }
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Months Covered</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Download Receipt</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row: PayoutDisbursal) => (
              <TableRow key={row._id}>
                <TableCell>{new Date(row.disbursalDate * 1000).toLocaleDateString()}</TableCell>
                <TableCell>{row.disbursalAmount}</TableCell>
                <TableCell>
                  {(row.billingIds || [])
                    .map((billing: PayoutBilling) => monthLabel(billing.month))
                    .join(", ")}
                </TableCell>
                <TableCell>
                  <Button variant="text" onClick={() => setSelected(row)}>
                    View Details
                  </Button>
                </TableCell>
                <TableCell>
                  <Button variant="text" onClick={() => handleReceipt(row._id)}>
                    Download Receipt
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {!rows.length ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="body2">No Disbursals found.</Typography>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>

      <TransactionDetailsModal
        open={Boolean(selected)}
        onClose={() => setSelected(null)}
        disbursal={selected}
      />
    </>
  );
};

export default DisbursalTab;
